import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RouteEnum } from '../../../enum/route.enum';
import { Address } from '../../../models/entity/address';
import { CustomerEntity } from '../../../models/entity/customer/customer.entity';
import { DeviceLocalStorageData } from '../../../models/rest/user/device-local-storage-data.model';
import { SessionStorageService } from '../../../services/session-storage.service';
import { DateFormatEnum } from '../../../enum/date-format.enum';
import { LoyaltyCardService } from '../../../services/loyalty/loyalty-card.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoyaltyCustomerDetailResponse } from '../../../models/rest/loyalty/loyalty-customer-detail-response';
import { LoyaltyCardAddUpdateComponent } from '../../loyalty/loyalty-card-add-update/loyalty-card-add-update.component';
import { ModalSizeEnum } from '../../../enum/modal-size.enum';
import { AlertifyService } from '../../../services/core/alertify.service';
import { LoyaltyCardSearchRequest } from '../../../models/rest/loyalty/loyalty-card-search-request.model';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { StringUtils } from '../../../utils/string.utils';
import { UserOperationalService } from '../../../services/user-operational.service';
import { RoleCodeEnum } from '../../../enum/role-code.enum';

@Component({
  selector: 'app-customer-info-widget',
  templateUrl: './customer-info-widget.component.html',
  styleUrls: ['./customer-info-widget.component.css']
})
export class CustomerInfoWidgetComponent implements OnInit {

  @Input() address: Address;
  @Input() customer: CustomerEntity;
  @Input() currentAccountBalance: number;
  @Input() bonusBalance: number;
  @Input() totalDebt: number;
  @Input() customerTypeName?: string;
  @Input() customerSourceName?: string;
  @Input() communityName?: string;
  @Input() showBillingDetail?: boolean = false;
  @Input() showParentCustomer?: boolean = false;
  @Input() isCustomerScreen?: boolean = false;
  @Input() isOrderScreen?: boolean = false;
  @Input() orderId?: number;


  deviceLocalStorageData: DeviceLocalStorageData;
  dateFormatEnum = DateFormatEnum;

  constructor(
    private router: Router,
    private sessionStorageService: SessionStorageService,
    private loyaltyCardService: LoyaltyCardService,
    private alertifyService: AlertifyService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private userOperationalService: UserOperationalService) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  get canDisplayPhoneUnmasked(): boolean {
    return this.userOperationalService.hasPermissionByRoleCode(RoleCodeEnum.DISPLAY_CUSTOMER_PHONE_NUMBER_UNMASK);
  }

  ngOnInit(): void {
    this.deviceLocalStorageData = this.sessionStorageService.getDeviceStorageData();
  }

  goParentCustomer() {

    this.router.navigate([`${RouteEnum.CUSTOMER_DETAIL}/${this.customer.parentCustomerId}`], { skipLocationChange: false });
  }


  async openLoyaltyCardUpdateModal() {
    try {

      if (StringUtils.isEmpty(this.customer.cardNumber)) {
        return;
      }

      let searchCriteria: LoyaltyCardSearchRequest = new LoyaltyCardSearchRequest();
      searchCriteria.cardNumber = this.customer.cardNumber;

      const res = await firstValueFrom(this.loyaltyCardService.getLoyaltyCardsBySearch(searchCriteria));

      if (res == null || res.length == 0) {
        this.alertifyService.error(this.translate.instant('message.info.loyalty-card-not-found'));
        return;
      }

      const modalRef = this.modalService.open(LoyaltyCardAddUpdateComponent, {
        backdrop: "static", centered: true, scrollable: false, size: ModalSizeEnum.MEDIUM
      });

      //modal  veri geçişi
      modalRef.componentInstance.data = res[0];
      modalRef.componentInstance.disableCardNumber = true;

      //modal cevap döndüğünde
      modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
        // modal kapat
        modalRef.close();
      });
    }
    catch (err) {

      this.alertifyService.error(err);
      return;

    }



  }


}
